import { KeyboardEvent } from 'react'

/**
 * Prevents special characters
 *
 * @param {KeyboardEvent<HTMLInputElement>} e
 */
export const preventSpecialCharactersEvent = (e: KeyboardEvent<HTMLInputElement>): void => {
  if (!/^[a-zA-Z0-9]/.test(e.key) || /^[ \-/.]/.test(e.key)) e.preventDefault()
}
